import { Filter, FilterRemove } from '@carbon/icons-react';
import React, { FunctionComponent } from 'react';

import { Button } from 'react-bootstrap';

interface FilterResetButtonProps {
    clickCallback: () => void;
    filtersApplied: boolean;
}

const FilterResetButton: FunctionComponent<FilterResetButtonProps> = (props: FilterResetButtonProps) => {
    const { filtersApplied, clickCallback } = props;

    return (
        <div className="filtersAppliedContainer">
            <Button
                variant="link"
                data-testid="filterResetButton"
                onClick={clickCallback}
                className={`${filtersApplied ? 'filters-applied' : 'no-filter'} filter-button`}
            >
                {filtersApplied ? (
                    <>
                        <img src="filter--reset.svg" className="button-icon-padding" alt="" height={20} width={20} />
                        <span className="no-filters">Reset All Filters</span>
                    </>
                ) : (
                    <>
                        <img src="filter--solid.svg" className="button-icon-padding" alt="" height={20} width={20} />
                        <span>No Filters Applied</span>
                    </>
                )}
            </Button>
        </div>
    );
};

export default FilterResetButton;
